import axios from '@/utils/axios'

export default async function GetCovers({queryKey}: any) {
  const {data} = await axios.get(
    process.env.NEXT_PUBLIC_API_URL +
      '/products/get-product-covers/' +
      queryKey[1],
  )
  return data
}
